import { router, usePage } from "@inertiajs/react";
import React, { useRef } from "react";
import ArticleCard from "../../Article/Components/ArticleCard";
import ChevronRightBlueIcon from "@/User/Assets/Svgs/ChevronRightBlueIcon.svg";
import { RouteName } from "@/User/Constants/routes";
import route from "ziggy-js";
import ArticleBlueIcon from "@/User/Components/Icons/ArticleBlueIcon";
import classNames from "classnames";
import { useCarousel } from "@/User/Components/useCarousel";
import { CAROUSEL_CARD, CAROUSEL_WRAPPER } from "@/User/Constants/elements";
import { LazyLoadImage } from "react-lazy-load-image-component";

const NewArticles = ({ isTopPage = true }) => {
    const { articleList } = usePage().props;
    const classSlideItem = `
        min-w-343px w-343px
    `;

    const handleRedirectArticlePage = () => {
        router.visit(route(RouteName.ArticlesPage));
    };
    const carouselRef = useRef(null);
    const { handleNextSlide, isHaveButton } = useCarousel(carouselRef);

    return articleList?.data.length > 0 && (
        <section className={classNames("container bg-white", {
            "py-6": isTopPage,
            "pb-2 pt-8 lg:pb-5 lg:pt-0": !isTopPage
        })}>
            {isTopPage ? (
                <div className="text-center text-primary mb-2">
                    <div className="flex justify-center items-center mb-2.5">
                        <ArticleBlueIcon width={18} height={18} />
                    </div>
                    <h2 className="leading-tight">新着記事</h2>
                </div>
            ) : (
                <h3 className="text-primary text-lg leading-[1.1] font-semibold px-3 py-1.5 border-l-4 border-primary lg:mt-0 mb-2.5">
                    新着記事
                </h3>
            )}

            <div className="flex">
                <div ref={carouselRef} className="mx-0 lg:mx-4 overflow-x-auto pb-4">
                    <div id={CAROUSEL_WRAPPER} className="flex gap-1">
                        {articleList.data.map((article) => (
                            <div id={CAROUSEL_CARD} className={`${classSlideItem}`} key={`article-${article.id}`}>
                                <ArticleCard article={article} />
                            </div>
                        ))}
                    </div>
                </div>
                {isHaveButton && (
                    <div className="content-center">
                        <div className="hidden lg:block bg-alice-blue-3 hover:bg-alice-blue-3/80 h-40 w-6">
                            <LazyLoadImage
                                className="w-full h-full cursor-pointer"
                                src={ChevronRightBlueIcon}
                                alt="Chevron Right Icon"
                                onClick={handleNextSlide}
                            />
                        </div>
                    </div>
                )}
            </div>

            <div className={classNames("text-right h-4.5 leading-5", {
                "mt-6": isTopPage,
                "mt-4": !isTopPage,
            })}>
                <p className="text-xs text-primary underline cursor-pointer" onClick={handleRedirectArticlePage} >その他の新着記事を見る</p>
            </div>
        </section>
    );
};

export default NewArticles;